<template>
  <div class="gaoya">
    <div class="total">
      <div class="top">
        <div class="left">
          <div class="item">
            <span>回路总数：</span>
            <span class="color1">{{ equipmentNumber.totalCount }}</span>
          </div>
          <div class="item">
            <span>正常：</span>
            <span class="color1">{{ equipmentNumber.normalCount }}</span>
          </div>
          <div class="item">
            <span>异常：</span>
            <span class="color2">{{ equipmentNumber.abnormalCount }}</span>
          </div>
        </div>
        <div class="right">
          <el-input placeholder="请输入现场编号" prefix-icon="el-icon-search" clearable v-model="input2">
          </el-input>
          <el-button type="primary" @click="searchInfo">搜索</el-button>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="item" :class="stateIndex == index ? 'active' : ''" v-for="(item, index) in states" :key="index"
            @click="stateIndex = index">
            {{ item }}
          </div>
        </div>
        <!-- <div class="right">
          <span>开关量状态：</span>
          <i class="color1"></i>
          <span>分闸</span>
          <i class="color2"></i>
          <span>合闸</span>
        </div> -->
      </div>
    </div>
    <div class="main-info">
      <section>
        <div class="card-box">
          <!-- @click="showLineChart(item)" -->
          <div class="card" v-for="(item, index) in equipmentList" :key="index">
            <div class="top">
              <div class="ctitle">
                <div class="left">
                  <img src="../../../assets/images/wenshidu.png" alt="" />
                  <p>{{ item.localeNumber }}</p>
                </div>
                <div class="right">
                  <!-- <el-switch
                    v-model="item.status2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch> -->
                  <!-- <myswitch :type="item.equipmentStatus"></myswitch> -->
                </div>
              </div>
              <div class="info">{{ item.equipmentDesc }}</div>
            </div>
            <div class="br"></div>
            <div class="bottom">
              <div class="item">
                <span>温度：</span>
                <span>{{ item.humitureList[0].value | getTwo }}℃</span>
              </div>
              <div class="item">
                <span>湿度：</span>
                <span>{{ item.humitureList[1].value | getTwo }}%</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <el-dialog title="温湿度变化" :visible.sync="dialogVisible" width="70%" height="80%">
      <div v-loading="dialogLoading">
        <div class="title">总配电室网络机柜</div>
        <div class="chart-box">
          <!-- option -->
          <v-chart :option="option" v-if="!nodata" ref="chart"></v-chart>
          <!-- <span v-if="nodata">暂无数据</span> -->
          <div class="image-box" v-if="nodata">
            <img src="../../../assets/images/nodata1.png" alt="" />
            <span class="nodata-txt">暂无数据</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ECharts from "vue-echarts";
  export default {
    components: { "v-chart": ECharts },
    data () {
      return {
        input2: "",
        dialogLoading: false,
        nodata: false,
        states: ["全部", "正常", "异常"],
        stateIndex: 0,
        switchValue: true,
        equipmentNumber: {},
        equipmentList: [],
        dialogVisible: false,
        option: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            right: "5%",
            top: "4%",
            data: ["温度", "湿度"],
          },
          color: ["rgba(245, 167, 50, 1)", "rgba(20, 96, 224, 1)"],
          grid: {
            left: "1%",
            right: "4%",
            bottom: "3%",
            top: "20%",
            containLabel: true,
          },
          xAxis: [
            // {
            //   show: false,
            //   position: "top",
            //   type: "time",
            //   boundaryGap: false,
            //   axisLabel: {
            //     color: "rgba(158, 158, 168, 1)",
            //     fontSize: 14,
            //   },
            //   axisLine: { show: false },
            //   axisTick: { show: false },
            //   splitLine: { show: false },
            // },
            {
              show: true,
              type: "category",
              boundaryGap: false,
              axisLabel: {
                color: "rgba(158, 158, 168, 1)",
                fontSize: 14,
              },
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
              position: "bottom",
              axisPointer: {
                type: "none",
              },
              data: [],
            },
          ],
          //         xAxis:
          // {show: true,
          // type: "category",
          // boundaryGap: false,
          // axisLabel: {
          //   color: "rgba(158, 158, 168, 1)",
          //   fontSize: 14,
          // },
          // axisLine: { show: false },
          // axisTick: { show: false },
          // splitLine: { show: false },
          // position: "bottom",
          // axisPointer: {
          //   type: "none",
          // },
          // data:[]},
          yAxis: {
            type: "value",
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: true },
          },
          series: [
            {
              name: "温度",
              type: "line",
              symbolSize: 0,
              lineStyle: {
                width: 4,
              },
              // areaStyle: {
              //   color: {
              //     type: "linear",
              //     x: 0,
              //     y: 0,
              //     x2: 0,
              //     y2: 1,
              //     colorStops: [
              //       {
              //         offset: 0,
              //         color: "rgba(245, 167, 50, 0.5)", // 0% 处的颜色
              //       },
              //       {
              //         offset: 1,
              //         color: "rgba(245, 167, 50, 0)", // 100% 处的颜色
              //       },
              //     ],
              //     global: false, // 缺省为 false
              //   },
              // },
              data: [],
            },
            {
              name: "湿度",
              type: "line",
              symbolSize: 0,
              lineStyle: {
                width: 4,
              },
              // areaStyle: {
              //   color: {
              //     type: "linear",
              //     x: 0,
              //     y: 0,
              //     x2: 0,
              //     y2: 1,
              //     colorStops: [
              //       {
              //         offset: 0,
              //         color: "rgba(20, 96, 224, 0.5)", // 0% 处的颜色
              //       },
              //       {
              //         offset: 1,
              //         color: "rgba(20, 96, 224, 0)", // 100% 处的颜色
              //       },
              //     ],
              //     global: false, // 缺省为 false
              //   },
              // },
              data: [],
            },
          ],
        },
        topicList: [],
        date: "",
      };
    },
    computed: {
      roomId () {
        return this.$store.state.roomId;
      },
    },
    watch: {
      roomId (v) {
        this.searchEquipmentStatusByType();
        this.searchHumitureMonitors();
      },
      stateIndex (n) {
        this.searchHumitureMonitors(n);
      },
      input2 (v) {
        if (!v) {
          this.searchHumitureMonitors();
          this.searchEquipmentStatusByType();
        }
      },
    },
    created () {
      this.searchEquipmentStatusByType();
      this.searchHumitureMonitors();
      this.date = this.$dateFormat("YYYY-mm-dd", new Date());
    },
    methods: {
      // 设备数量及状态统计
      searchEquipmentStatusByType () {
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post(
              "bma-distribution-service/realTimeMonitoring/searchEquipmentStatusByType",
              {
                equipmentType: 8,
                localeNumber: this.input2,
                roomId: this.roomId,
              }
            )
            .then((res) => {
              this.equipmentNumber = res.data;
            });
        }
      },
      searchInfo () {
        this.searchHumitureMonitors();
        this.searchEquipmentStatusByType();
      },
      // 查询列表
      searchHumitureMonitors (n) {
        let equipmentStatus = null;
        if (n == 1) {
          equipmentStatus = 1;
        } else if (n == 2) {
          equipmentStatus = 0;
        }
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post("bma-distribution-service/realTime/searchHumitureMonitors", {
              roomId: this.roomId,
              localeNumber: this.input2,
              equipmentStatus: equipmentStatus,
            })
            .then((res) => {
              if (res.data) {
                res.data.forEach((item) => {
                  item.status2 = !!item.status;
                  // 实时
                  item.humitureList.forEach((j) => {
                    if (this.topicList.indexOf(j.subscribeField) == -1) {
                      this.topicList.push(j.subscribeField);
                    }
                    this.$timeing(j.subscribeField, j.subscribeField, (res) => {
                      const body = JSON.parse(res.body);
                      this.equipmentList.forEach((i) => {
                        i.humitureList.forEach((j) => {
                          if (j.subscribeField.indexOf(body.field) > -1) {
                            j.value = body.value;
                          }
                        });
                      });
                    });
                  });
                });
                this.equipmentList = res.data;
              }
            });
        }
      },
      // 显示折线图
      showLineChart (e) {
        console.log(e);
        this.dialogLoading = true;
        this.dialogVisible = true;
        let data1 = [];
        let data2 = [];
        let times = [];
        this.$http
          .post("bma-distribution-service/realTime/searchHumitureGraph", {
            equipmentCode: e.equipmentCode,
          })
          .then((res) => {
            console.log(res);
            // 清空表格
            if (this.$refs.chart) {
              this.$refs.chart.clear();
            }
            if (res.data && res.data.length > 0) {
              this.nodata = false;
              // let times2=[]
              // data1.push([
              //   res.data[0].dataList[0].date.substring(0, 14)
              //     ? res.data[0].dataList[0].date.substring(0, 14) + "00:00"
              //     : this.$dateFormat("YYYY-mm-dd", new Date(this.date)) +
              //       "00:00:00",
              //   0,
              // ]);
              // data2.push([
              //   res.data[1].dataList[0].date.substring(0, 14)
              //     ? res.data[1].dataList[0].date.substring(0, 14) + "00:00"
              //     : this.$dateFormat("YYYY-mm-dd", new Date(this.date)) +
              //       "00:00:00",
              //   0,
              // ]);
              // alert((res.data[0].dataList[0].date).substring(0,14) )
              res.data[0].dataList.forEach((res, index) => {
                let arr = [res.date, res.value];
                times.push(res.date);
                data1.push(arr);
              });
              res.data[1].dataList.forEach((res, index) => {
                let arr = [res.date, res.value];
                data2.push(arr);
              });
              this.option.xAxis[0].data = times;
              this.option.series[0].data = data1;
              this.option.series[1].data = data2;
              console.log("this.option: ", this.option);
              console.log(this.option);
            } else {
              this.nodata = true;
            }
            this.dialogLoading = false;
          });
      },
    },
    beforeDestroy () {
      this.topicList.forEach((item) => {
        this.$clearTimeing(item);
      });
    },
  };
</script>

<style lang="less" scoped>
  .image-box {
    height: 100%;
    width: 100%;

    img {
      height: 40%;
      margin: 10% 38% 2%;
    }

    .nodata-txt {
      margin-left: 47%;
      font-size: 20px;
    }
  }

  .gaoya {
    margin-top: -15px;

    .total {
      width: 100%;
      background: #f8f8f9;
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;

          .item {
            border: 1px solid #eaedef;
            border-radius: 21px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            padding: 0 27px;
            margin-right: 37px;

            span {
              font-weight: 600;

              &.color1 {
                color: rgba(20, 96, 224, 1);
              }

              &.color2 {
                color: rgba(224, 20, 20, 1);
              }
            }
          }
        }

        .right {
          display: flex;

          .el-input {
            margin-right: 10px;
          }
        }
      }

      .bottom {
        margin-top: 30px;
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        .left {
          display: flex;

          .item {
            margin-right: 30px;
            font-size: 16px;
            position: relative;
            padding-bottom: 15px;
            cursor: pointer;

            &.active {
              font-weight: 600;
              border-bottom: 3px solid rgba(20, 96, 224, 1);
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #0e223d;

          i {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin: 0 15px;

            &.color1 {
              background: rgba(61, 224, 159, 1);
            }

            &.color2 {
              background: rgba(248, 113, 113, 1);
            }
          }
        }
      }
    }

    .main-info {
      padding: 15px;

      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 9px 18px;
        background: #fff;
        border-radius: 7px;
        width: 106px;
        line-height: 40px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
        margin-bottom: 15px;

        .icon-box {
          width: 15px;
          height: 15px;
          background: rgba(20, 96, 224, 1);
          text-align: center;
          line-height: 15px;
          margin-right: 5px;

          i {
            color: #fff;
          }
        }

        p {
          font-weight: 600;
        }
      }

      .card-box {
        display: flex;
        flex-wrap: wrap;

        .card {
          width: 381px;
          height: 170px;
          background: #ffffff;
          box-shadow: 0px 3px 6px rgba(40, 76, 122, 0.1);
          opacity: 1;
          border-radius: 8px;
          cursor: pointer;
          margin-right: 36px;
          margin-bottom: 20px;

          &:nth-of-type(4n) {
            margin-right: 0;
          }

          .top {
            padding: 9px 20px;
            border-bottom: 1px solid #e9e9e9;

            .ctitle {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .left {
                display: flex;
                align-items: center;

                img {
                  width: 42px;
                  margin-right: 7px;
                }

                p {
                  font-weight: 600;
                }
              }
            }

            .info {
              color: #7d7d7d;
              line-height: 22px;
              font-size: 18px;
              font-weight: 600;
              margin-top: 10px;
              height: 45px;
            }
          }

          .br {
            width: 104px;
            height: 1px;
            background: #1460e0;
            margin-top: -1px;
          }

          .bottom {
            display: flex;
            cursor: pointer;

            .item {
              width: 50%;
              text-align: center;
              line-height: 56px;

              span {
                font-weight: 600;

                &:last-of-type {
                  color: rgba(245, 167, 50, 1);
                }
              }

              &:last-of-type {
                span {
                  &:last-of-type {
                    color: rgba(20, 96, 224, 1);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  /deep/.el-dialog {
    .el-dialog__body {
      padding: 0 20px;
    }

    .title {
      font-size: 26px;
      font-weight: 500;
      line-height: 44px;
      color: #152139;
      opacity: 1;
    }

    .chart-box {
      width: 100%;
      height: 35vw;
      padding-bottom: 30px;
    }
  }
</style>